import { EventEmitter } from '../base/event';
export class ProductModel extends EventEmitter {
    constructor() {
        super();
        this.products = [];
    }
    async fetchProducts() {
        this.products = [
            {
                id: '1',
                title: 'Фреймворк куки судьбы',
                description: 'Уникальная возможность прописать свою судьбу на JavaScript.',
                price: 2500,
                category: 'софт-скил',
                image: ''
            },
            {
                id: '2',
                title: '+1 час в сутках',
                description: 'Для тех, кто успевает всё.',
                price: 750,
                category: 'другое',
                image: ''
            },
            {
                id: '3',
                title: 'БЭМ-пилюлька',
                description: 'Вылечит любую верстку за 5 минут.',
                price: 150000,
                category: 'хард-скил',
                image: ''
            },
            {
                id: '4',
                title: 'React-антистресс',
                description: 'Снимает тревогу при работе с состоянием компонентов.',
                price: 1000,
                category: 'хард-скил',
                image: ''
            }
        ];
        console.log('Loaded mock products:', this.products);
        this.emit('products-updated', this.products);
    }
    getProductById(id) {
        return this.products.find(product => product.id === id);
    }
    getAllProducts() {
        return [...this.products];
    }
}
